module.exports = __webpack_public_path__ + "fa85fdd9834aa2b99604e5497c3dc1.svg";